export const SIZES = [
  {
    text: 'Large',
    value: 'l',
    readableName: 'Large',
  },
  {
    text: 'Medium',
    value: 'm',
    readableName: 'Medium',
  },
  {
    text: 'Small',
    value: 's',
    readableName: 'Small',
  },
  {
    text: 'Extra Small',
    value: 'extra-small',
    readableName: 'Extra Small',
  },
  {
    text: 'Non-Dresden',
    value: 'nd',
    readableName: 'Non-Dresden',
  },
];

// Saved orders hold sizes as "Large", "large", "L", "l", "extra-small", "Non-Dresden" and, for some
// older arms, with the frame shape in front ("roundl"). Compare without case, spaces, "_" or "-".
const normalizeSize = value =>
  String(value)
    .toLowerCase()
    .replace(/[\s_-]+/g, '')
    .replace(/^(round|classic|original|capote)(?=[sml]$)/, '');

const SIZE_ALIASES = { xs: 'extrasmall', xsmall: 'extrasmall' };

export const findSize = value => {
  if (value === null || value === undefined || value === '') return null;
  const normalized = normalizeSize(value);
  const key = SIZE_ALIASES[normalized] || normalized;
  return (
    SIZES.find(size => normalizeSize(size.value) === key || normalizeSize(size.readableName) === key) ||
    null
  );
};
